export const STAGED_CHAT_PROMPT_QUERY_PARAM = 'stagedChatPrompt'

const STAGED_CHAT_PROMPT_STORAGE_PREFIX = 'tripPlanner:stagedChatPrompt:'

interface StagedChatPrompt {
  prompt: string
}

const stagedChatPromptMemory = new Map<string, StagedChatPrompt>()

function createStagedChatPromptToken(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

interface StagedChatPromptReference {
  token: string
}

export function stageChatPrompt(prompt: string, storagePrefix = STAGED_CHAT_PROMPT_STORAGE_PREFIX): StagedChatPromptReference {
  const token = createStagedChatPromptToken()
  const storageKey = `${storagePrefix}${token}`
  const stagedPrompt: StagedChatPrompt = {
    prompt,
  }

  try {
    window.sessionStorage.setItem(
      storageKey,
      JSON.stringify(stagedPrompt),
    )
  } catch {
    stagedChatPromptMemory.set(storageKey, stagedPrompt)
  }

  return { token }
}

export function buildStagedChatPromptQuery(prompt: string): string {
  const stagedPrompt = stageChatPrompt(prompt)
  const queryParams = new URLSearchParams({
    [STAGED_CHAT_PROMPT_QUERY_PARAM]: stagedPrompt.token,
  })

  return queryParams.toString()
}

export function consumeStagedChatPrompt(
  token: string | null | undefined,
  storagePrefix = STAGED_CHAT_PROMPT_STORAGE_PREFIX,
): string | undefined {
  if (!token) return undefined

  const storageKey = `${storagePrefix}${token}`

  if (typeof window !== 'undefined') {
    try {
      const stagedPrompt = JSON.parse(window.sessionStorage.getItem(storageKey) ?? 'null') as StagedChatPrompt | null
      window.sessionStorage.removeItem(storageKey)

      if (typeof stagedPrompt?.prompt === 'string') {
        return stagedPrompt.prompt
      }
    } catch {
      try {
        window.sessionStorage.removeItem(storageKey)
      } catch {
        // no-op: storage may be unavailable, in which case the in-memory fallback is used.
      }
    }
  }

  const stagedPrompt = stagedChatPromptMemory.get(storageKey)
  stagedChatPromptMemory.delete(storageKey)

  if (typeof stagedPrompt?.prompt === 'string') {
    return stagedPrompt.prompt
  }

  return undefined
}
